var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Status',{attrs:{"value":_vm.active,"ok-label":_vm.$t('rooms.active'),"ko-label":_vm.$t('rooms.deleted')}})
}
var staticRenderFns = []

export { render, staticRenderFns }